<template>
  <div class="h5content">
    <template v-for="(item, index) in list" :key="index">
      <MedicalItem class="mb12" :isMobile="true" :medicalItem="item" />
    </template>
    <EmptyImgh5 v-if="list.length == 0"></EmptyImgh5>
  </div>
</template>

<script>
//components
import MedicalItem from "@/components/patient/medical.vue";

import { patientEmrList } from "@/api/patient.js";
import { userStore } from "@/store/user.js";
import { loadingStore } from "@/store/loading.js";

export default {
  name: "electronicMedicalRecords",
  props: [],
  components: {
    MedicalItem,
  },
  data: function () {
    return {
      list: [],
    };
  },
  setup() {
    let loading = loadingStore();
    return {
      loading,
    };
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    getList() {
      let that = this;
      const aloginStoreuth = userStore();
      let subdata = {
        emrType: "1,2",
        cusId: aloginStoreuth.cusId,
        corpId: aloginStoreuth.corpId,
      };
      that.loading.showLoading();

      patientEmrList(subdata).then((res) => {
        that.loading.hideLoading();
        let { data } = res.data;

        if (data && data.length > 0) {
          this.list = data;
        }
      });
    },
    formatContent(val) {
      // 把文本中的 \n 换成<br />
      return val.replace(/\n/g, "<br />");
    },
  },
};
</script>

<style lang="scss" scoped></style>
